import { render, staticRenderFns } from "./DataInfo.vue?vue&type=template&id=1bab0ab6&scoped=true&"
import script from "./DataInfo.vue?vue&type=script&lang=js&"
export * from "./DataInfo.vue?vue&type=script&lang=js&"
import style0 from "./DataInfo.vue?vue&type=style&index=0&id=1bab0ab6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bab0ab6",
  null
  
)

component.options.__file = "DataInfo.vue"
export default component.exports